module.exports = __webpack_public_path__ + "img/postgraduate.29298135.png";